import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { landingMotionInView } from "@/utils/landingMotion";
import { PiTelegramLogo, PiYoutubeLogo, PiLinkedinLogo } from "react-icons/pi";
import { TbBrandCrunchbase } from "react-icons/tb";
import urfxLogoLight from "/assets/Navbar/dark-logo.svg";
import { FaInstagram } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
export default function Footer() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const shopLinks = [
    { name: "Instant Funding", phase: 3 },
    { name: "Two-Step Challenge", phase: 2 },
    { name: "One-Step Challenge", phase: 1 },
    { name: "Trading Rules", link: "/trading-rules" }
  ];

  const Legallinks = [

    {
      name: "Terms and Conditions",
      link: "/terms-&-conditions"
    },
    {
      name: "Privacy Policy",
      link: "/privacy-policy"
    },
    {
      name: "Contact Support",
      link: "/support"
    },

  ];

  const navigationLinks = [
    {
      name: "Home",
      link: "/"
    },
    {
      name: "Pricing",
      link: "/pricing"
    },
    {
      name: "Dashboard",
      link: "/user/dashboard"
    },
    {
      name: "About",
      link: "/about-us"
    },
    {
      name: "FAQs",
      link: "/faqs"
    },
    {
      name: "Contact",
      link: "/contact-us"
    }
  ]

  return (
    <footer className="relative w-full bg-black text-white overflow-hidden font-nexa -mt-24 xl:-mt-28 px-4 xl:px-10">
      {/* Detailed Disclaimer Section */}
      <motion.div
        className="mt-12 w-full rounded-[28px] border border-white/10 bg-[linear-gradient(180deg,rgba(255,255,255,0.06)_0%,rgba(0,0,0,0.75)_100%)] backdrop-blur-[20px] bg-no-repeat bg-cover bg-center  shadow-[0_18px_80px_rgba(0,0,0,0.55)]  "
        style={{
          backgroundImage: "url('/assets/landingpage/footer/ellipse.png')",
        }}
      >

        {/* Main Footer Content */}
        <div className="relative max-w-[1400px] mx-auto  pt-32 md:pt-40 pb-5 px-5 xl:px-20 w-full  bg-no-repeat bg-cover bg-center "

        >
          <motion.div
            className="grid grid-cols-1 md:grid-cols-3 xl:grid-cols-5 gap-10 lg:flex-row lg:items-start lg:justify-between"

          >
            {/* Left: logo + CTA */}
            <div className="w-full max-w-[520px] md:col-span-3 xl:col-span-2">
              <img
                src={urfxLogoLight}
                alt="URFX Logo"
                className="h-[32px] sm:h-[41px] w-full md:w-auto"
              />
              <p className="pt-10 md:pt-16 max-w-[440px] font-creato text-center md:text-left text-sm md:text-lg text-white/70 leading-relaxed">
                Got a question or need some help? Get in touch. We'd love to hear from you.
              </p>

              <div className="mt-6 flex flex-wrap gap-4">
                <Link
                  to="/signup"
                  className="btn-register rounded-[10px] px-6 py-2.5 text-[16px] w-full md:w-fit font-bold"
                >
                  {t("Register")}
                </Link>
                <Link
                  to="https://t.me/urfxofficial"
                  target="_blank"
                  className="btn-gradient-left px-6 py-2.5 text-[16px] w-full md:w-fit font-bold !rounded-[10px]"
                >
                  {t("Talk To Sales")}
                </Link>
              </div>
              {/* social icons through react icons */}
              <div className="mt-9 text-center md:text-left ">
                <h3 className="text-lg md:text-xl font-primary font-medium mb-2">Follow us on</h3>
                <div className="flex gap-2 justify-center md:justify-start">
                  <a href="https://www.instagram.com/urfxglobal" target="_blank" rel="noopener noreferrer">
                    <FaInstagram size={28} className="text-white hover:text-[#dbd633] transition-all duration-300" />
                  </a>
                  <a href="https://x.com/urfxio" target="_blank" rel="noopener noreferrer">
                    <FaXTwitter size={26} className="text-white hover:text-[#dbd633] hover:border-[#dbd633] border-2 p-1 rounded-md transition-all duration-300" />
                  </a>
                  <a href="https://t.me/urfxchannel" target="_blank" rel="noopener noreferrer">
                    <PiTelegramLogo size={28} className="text-white hover:text-[#dbd633] transition-all duration-300" />
                  </a>
                  <a href="https://www.youtube.com/watch?v=_M0Pqfo2k-o" target="_blank" rel="noopener noreferrer">
                    <PiYoutubeLogo size={28} className="text-white hover:text-[#dbd633] transition-all duration-300" />
                  </a>
                  <a href="https://www.linkedin.com/company/urfx" target="_blank" rel="noopener noreferrer">
                    <PiLinkedinLogo size={28} className="text-white hover:text-[#dbd633] transition-all duration-300" />
                  </a>
                  <a href="https://www.crunchbase.com/organization/urfx" target="_blank" rel="noopener noreferrer">
                    <TbBrandCrunchbase size={28} className="text-white hover:text-[#dbd633] transition-all duration-300" />
                  </a>
                </div>
              </div>
            </div>
            {/* mid div starts here  */}
            <div className=" text-center md:text-left">
              <h3 className="text-xl sm:text-2xl bold mb-3">
                Navigation
              </h3>
              <ul className="space-y-1 text-sm md:text-lg text-white/50 font-normal">
                {navigationLinks.map((item) => (
                  <li key={item.name} className="hover:underline cursor-pointer transition-colors">
                    <Link to={item.link} className="hover:underline cursor-pointer transition-colors">
                      {item.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Right: Programs/About + Reviews */}
            <div className="w-full lg:max-w-[470px] md:col-span-2">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-8">
                <div className="text-center md:text-left">
                  <h3 className="text-xl sm:text-2xl bold mb-3">
                    Programs
                  </h3>
                  <ul className="space-y-1 text-sm md:text-lg text-white/50 font-normal">
                    {shopLinks.map((item) => (
                      <li key={item.name}>
                        {item.phase !== undefined ? (
                          <button
                            onClick={() => {
                              navigate(`/?phase=${item.phase}#featureSection`);
                              setTimeout(() => {
                                const element = document.getElementById("featureSection");
                                element?.scrollIntoView({ behavior: "smooth" });
                              }, 100);
                            }}
                            className="hover:underline cursor-pointer transition-colors text-left"
                          >
                            {item.name}
                          </button>
                        ) : (
                          <Link to={item.link} className="hover:underline cursor-pointer transition-colors">
                            {item.name}
                          </Link>
                        )}
                      </li>
                    ))}
                  </ul>
                  <p className="text-[10px] tracking-wider text-white/50 font-light mt-2">
                    All programs redirect directly to secure checkout.
                  </p>
                </div>

                <div className="text-center md:text-left">
                  <h3 className="text-xl sm:text-2xl bold mb-3">
                    Legal
                  </h3>
                  <ul className="space-y-1 text-sm sm:text-lg text-white/50 font-normal">
                    {Legallinks.map((item) => (
                      <li key={item.name} className="hover:underline cursor-pointer transition-colors">
                        <Link to={item.link} className="hover:underline font-creato cursor-pointer transition-colors">
                          {item.name}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

              {/* Reviews block */}
              <div className="mt-8 space-y-2  gap-4 text-center md:text-left">
                <img
                  src={'/assets/landingpage/footer/reviews.svg'}
                  alt="URFX customer reviews"
                  className="h-[40px] w-full md:w-auto"
                />
                <div className="grid grid-cols-2 md:flex items-center gap-2 md:gap-3">
                  <a href="http://propfirmlabs.com/" target="_blank" rel="noopener noreferrer">
                    <img
                      src={'/assets/landingpage/footer/propfirm.svg'}
                      alt="PropFirmLabs rating"
                      className="h-16 md:h-[40px] w-full md:w-auto"
                    />
                  </a>

                  <a href="https://www.trustsadvisor.com/businesses/urfx.io" target="_blank" rel="noopener noreferrer">
                    <img
                      src={'/assets/landingpage/footer/trust.svg'}
                      alt="TrustsAdvisor rating"
                      className="h-16 md:h-10 w-full md:w-auto "
                    />
                  </a>
                  <a href="https://www.provenexpert.com/en-us/urfx-io/" target="_blank" rel="noopener noreferrer">
                    <img
                      src={'/assets/landingpage/footer/expert.svg'}
                      alt="ProvenExpert rating"
                      className="h-16 md:h-10 w-full md:w-auto "
                    />
                  </a>

                  <a href="https://www.trustindex.io/reviews/urfx.io" className="h-full" target="_blank" rel="noopener noreferrer">
                    <img
                      src={'/assets/landingpage/footer/trustindex.svg'}
                      alt="Trustindex reviews"
                      className="h-16 md:h-10 w-full md:w-auto "
                    />
                  </a>
                </div>
              </div>


              <div className=" text-center md:text-end text-sm  md:text-base text-white/40 mt-8">
                Copyright 2027 URFX All Rights Reserved.
              </div>
            </div>
          </motion.div>

          <motion.div
            className="space-y-6 sm:space-y-8 text-[11px] sm:text-[13px] 2k:text-[16px] border-t border-white/30 pt-8 mt-8 font-nexa"
            {...landingMotionInView}
          >
            {/* Important Information Header */}
            <div className="text-start md:text-center pb-4">
              <h2 className="text-xl md:text-2xl font-bold font-creato tracking-wide text-gradient">
                {t("IMPORTANT INFORMATION & DISCLAIMER")}
              </h2>
            </div>

            <motion.div className="space-y-2" {...landingMotionInView}>
              <p className=" font-creato text-sm md:text-base">
                URFX is a modern prop trading firm offering instant-funded accounts, fair profit splits, transparent trading rules, and AI-driven risk management tools to help skilled traders grow without risking their own capital.
              </p>
            </motion.div>
            {/* Company Information */}
            <div className="space-y-2">
              <p className=" font-creato text-sm md:text-base">
                {t("URFX, hereinafter referred to as 'the Company', provides all published and distributed content for informational purposes only. The information contained on the Company's websites, platforms, and materials is not intended to be relied upon for making investment decisions.")}
              </p>
            </div>



            {/* No Investment Services */}
            <div className="space-y-2">
              <h3 className="text-xl  md:text-2xl font-bold">
                {t("No Investment Services")}
              </h3>
              <p className=" font-creato text-sm md:text-base">
                {t("URFX does not provide investment, brokerage, or financial services of any kind. All trading activities conducted through URFX are performed using virtual funds only and are not connected to real financial markets.")}
              </p>
              <ul className="list-disc pl-5 sm:pl-6 space-y-1.5 py-4 font-creato text-sm md:text-base">
                <li>{t("URFX does not provide investment advice or financial recommendations.")}</li>
                <li>{t("URFX does not solicit or facilitate the purchase or sale of financial instruments, securities, or assets.")}</li>
                <li>{t("URFX does not act as a broker, custodian, or financial intermediary.")}</li>
                <li>{t("URFX does not handle, transmit, or manage client funds.")}</li>
              </ul>
              <p className=" mt-2  font-creato text-sm md:text-base">
                {t("Participation in URFX programs is entirely voluntary. All fees paid to URFX are service fees — not deposits or investments — and are non-refundable once paid, except where required by law. These fees are applied toward operational costs such as technology infrastructure, licensing, compliance, software systems, and customer support.")}
              </p>
            </div>

            {/* General Risk Warning */}
            <div className="space-y-2">
              <h3 className="text-xl  md:text-2xl font-bold">
                {t("General Risk Warning")}
              </h3>
              <p className=" font-creato text-sm md:text-base">
                {t("Trading financial markets involves a substantial risk of loss. Even within a simulated environment, trading strategies tested under leveraged conditions may yield results that differ from real-world trading. Participants should carefully evaluate their objectives, financial situation, and experience level before engaging in any simulated trading activities.")}
              </p>
            </div>

            {/* Disclosure on Hypothetical Performance */}
            <div className="space-y-2">
              <h3 className="text-xl  md:text-2xl font-bold">
                {t("Disclosure On hypothetical performance")}
              </h3>
              <p className=" font-creato text-sm md:text-base">
                {t("All accounts provided by URFX operate exclusively within a simulated trading environment. No actual trades are executed on live financial markets. The services and programs offered by URFX are designed solely for educational, analytical, and evaluation purposes. Hypothetical performance results come with inherent limitations, among which include the fact that they do not reflect actual trading. No claim is made that any account will achieve or is likely to achieve profits or losses comparable to those discussed; in reality, actual results can significantly differ from those predicted by hypothetical performance. Hypothetical performance often benefits from hindsight, does not account for financial risk, and cannot consider the financial risk in actual trading. For instance, the capacity to endure losses or to stick to a trading plan despite losses are crucial factors that can negatively impact real trading results. Many other market factors or aspects of implementing a specific trading program not accounted for in hypothetical performance preparation can also adversely affect actual trading results.")}
              </p>
            </div>

            {/* Limitation of Liability */}
            <div className="space-y-2">
              <h3 className="text-xl  md:text-2xl font-bold">
                {t("Limitation Of Liability")}
              </h3>
              <p className=" font-creato text-sm md:text-base">
                {t("URFX shall not be held liable for any losses, damages, or claims resulting from the use or misuse of its platform, tools, or simulated trading systems. Participation in any URFX program constitutes acknowledgment and acceptance of all company terms, policies, and rules.")}
              </p>
            </div>
            {/* Restricted Jurisdictions */}
            <div className="space-y-2">
              <h3 className="text-xl  md:text-2xl font-bold">
                {t("Restricted Jurisdictions")}
              </h3>
              <p className=" font-creato text-sm md:text-base">
                {t("Our services are not available to residents, citizens, or persons located in Russia, Iran, Myanmar, or North Korea. Any user from these jurisdictions is prohibited from registering for or using our services. We reserve the right to deny access, suspend accounts, or terminate services to ensure compliance with applicable legal and regulatory requirements.")}
              </p>
            </div>

            {/* Contact Information */}
            <div className="space-y-2">
              <p className=" font-creato text-sm md:text-base">
                {t("For more information on simulated trading services provided by URFX please contact ")} {" "}
                {
                  <a href="mailto:help@urfx.io" className="text-gradient font-creato hover:underline">help@urfx.io</a>
                }
              </p>
            </div>

          </motion.div>
        </div>
      </motion.div>


    </footer>
  );
}
